module.exports = __webpack_public_path__ + "static/img/fish8.929334c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish8.png
// module id = r4Tk
// module chunks = 0